export default {
  pcLayout: {
    quotationDeadline: '报价截止时间',
    expectedArrivalTime: '期望到达时间',
    expectedDeliveryTime: '期望送到时间',
    addresses: '装箱门点及尾程送货地址',
    quantity: '数量',
    amount: '金额',
    actions: '操作',
    deleteFee: '删除费用',
    loadingAddress: '装箱门点',
    deliveryAddress: '尾程送货地址'
  },

  // 地址类型枚举（对应 pre_address_type / last_address_type 字段）
  addressType: {
    seaport: '海港',
    airport: '机场',
    railwayStation: '铁路站点'
  },

  // 报价变更格式化工具
  changeFormatter: {
    itemAdded: '{project} 新增了',
    itemDeleted: '{project} 被删除了',
    projectChanged: '{oldProject} 变更成 {newProject}',
    amountChanged: '金额由 {oldAmount} {oldCurrency} 调整为 {newAmount} {newCurrency}',
    projectWithChange: '{project} {change}',
    separator: '，'
  },

  // 供应商报价详情页
  supplierQuotationDetail: {
    // 供应商信息
    supplierName: '供应商名称',
    inquirer: '询价方',
    onePriceSupported: 'All In 价格',
    flightNo: '航班号',
    validPeriod: '报价有效期',
    validPeriodSeparator: '至',
    roroQuotationTitle: '滚装报价详情',
    bulkCargoQuotationTitle: '散杂货报价详情',
    totalAmount: '总计金额',
    totalAmountByCurrency: '分币种合计',
    feeDetails: '费用明细',
    oceanFreight: '海运费',
    perContainerPrice: '单柜价格',
    originCharges: '起运港费用',
    destCharges: '目的港费用',
    potentialCharges: '潜在费用',
    potentialChargesTip: '可能会发生的费用，暂不计入总价',
    addOceanSurcharge: '添加海运附加费',
    addOriginCharge: '添加起运港费用',
    addDestCharge: '添加目的港费用',
    addPotentialCharge: '添加潜在费用',
    prepaid: '预付',
    collect: '到付',
    perContainer: '按箱',
    perBill: '按票',
    containerType: '箱型',

    roro: {
      title: '车辆信息',
      itemTitle: '车辆 {index}',
      vehicleType: '车辆类型',
      brandModel: '品牌/型号',
      quantity: '车辆数量',
      lengthMm: '车辆长度(mm)',
      widthMm: '车辆宽度(mm)',
      heightMm: '车辆高度(mm)',
      weightTon: '车辆重量(吨)',
      remarks: '备注',
      empty: '暂无车辆明细',
      scheduleTitle: '船期要求',
      expectedEtd: '期望ETD',
      expectedEta: '期望ETA',
      acceptTransit: '是否接受中转',
      transitDaysRequirement: '航程天数要求',
      transitDaysWithin: '{days}天以内'
    },

    bulkCargo: {
      title: '散杂货信息',
      itemTitle: '货物 {index}',
      cargoKind: '货种',
      tonnage: '吨位',
      volume: '体积',
      stowageFactor: '积载因数',
      packagingType: '包装方式',
      liftingRequirements: '吊装要求',
      receivingInstructions: '特殊接货说明',
      remarks: '备注',
      groupCount: '货物组数',
      totalTonnage: '总吨位',
      totalVolume: '总体积',
      empty: '暂无散杂货明细'
    },

    // 报价明细
    quotationDetail: '报价明细',
    serviceContent: '服务内容',
    addItem: '新增',
    project: '项目名称',
    projectPlaceholder: '请输入项目名称',
    feeType: '费用类别',
    feeTypes: {
      0: '基础海运费',
      1: '海运附加费',
      2: '起运港费用',
      3: '目的港费用',
      4: '潜在费用'
    },
    placeholders: {
      selectOption: '请选择'
    },
    unit: '单位',
    unitPlaceholder: '单位',
    quantity: '数量',
    quantityPlaceholder: '数量',
    unitPrice: '单价',
    unitPricePlaceholder: '单价',
    amount: '金额',
    currency: '币种',
    currencyPlaceholder: '币种',
    remarks: '备注',
    remarksPlaceholder: '备注',
    operations: '操作',
    deleteRow: '删除',

    // 单位选项
    units: {
      container: '柜',
      ticket: '票',
      ton: '吨',
      cbm: '立方米',
      bill: '票',
      set: '套'
    },

    // 币种选项
    currencies: {
      CNY: 'CNY',
      USD: 'USD',
      EUR: 'EUR',
      HKD: 'HKD'
    },

    // 磋商记录
    consultationHistory: '磋商记录',
    initiateConsultation: '发起新磋商',
    consultationContent: '磋商内容',
    consultationContentPlaceholder: '请输入磋商内容',
    initiatedByInquirer: '询价方发起',
    initiatedByQuoter: '报价方发起',
    reply: '回复',
    attachment: '附件',
    updatedBy: '更新人',
    updateTime: '更新时间',
    changeContent: '变更内容',
    consultationRemarks: '磋商备注',
    initialVersion: '初始版本',
    currentVersion: '当前版本',
    reduced: '降价',
    noChange: '暂无变更',
    noConsultationRecords: '暂无磋商记录',

    // 磋商状态
    consultationStatus: {
      notConsulted: '未磋商',
      inProgress: '磋商中',
      completed: '磋商完成'
    },

    // 航程信息
    voyageInfo: '航程信息',
    etd: '预计船期',
    eta: '预计到港',
    voyageFlight: '船名航次',
    transportationDays: '运输天数',
    days: '天',
    durationUnits: {
      day: '天',
      hour: '时',
      minute: '分',
      compactDay: 'D',
      compactHour: 'H',
      compactMinute: 'M'
    },

    // SHOKZ 报价服务字段
    serviceFields: {
      serviceType: '服务类型',
      serviceTypePlaceholder: '请选择服务类型',
      demurrageFreeDays: '免堆存期',
      detentionFreeDays: '免用箱期',
      weightLimit: '限重',
      routeGrade: '航线等级',
      routeGradeNormal: '普通',
      routeGradeExpress: '快速',
      serviceTypes: {
        seaFcl: '整箱',
        seaLcl: '拼箱',
        roro: '滚装',
        breakBulk: '散杂货',
        looseCargo: '散货',
        fullPallet: '整托',
        fullCabin: '整舱',
        charter: '包机',
        prePort: '港前运输',
        lastMile: '尾程运输'
      },
      shippingLine: '船公司',
      airline: '航空公司',
      carrier: '承运商',
      railwayCompany: '铁路公司',
      estimatedDepartureTime: '预计起飞时间',
      estimatedArrivalTime: '预计到达时间',
      vessel: '船名',
      voyage: '航次',
      bargeVessel: '驳船船名',
      bargeVoyage: '驳船航次',
      trainNo: '车次',
      bargeDepartureTime: '驳船开航时间',
      bargeArrivalTime: '驳船到港时间',
      trainDepartureTime: '发车时间',
      directTransit: '直达/中转',
      transferPort: '中转港',
      multipleSelectionPlaceholder: '支持多选',
      singleSelectionPlaceholder: '请选择一个中转节点',
      locationPlaceholder: '请选择{location}',
      originPort: '起运港',
      destinationPort: '卸货港',
      stuffingTerminal: '装箱码头/堆场',
      deliveryTerminal: '交货码头/堆场',
      loadingPort: '装货港',
      dischargingPort: '卸货港',
      arrivalPort: '抵达港',
      arrivalStation: '抵达站',
      dischargingStation: '卸货站',
      dischargingAirport: '卸货机场',
      arrivalTerminal: '抵达码头',
      originTerminal: '卸货码头',
      arrivalAirportTerminal: '抵达机场货站',
      originAirportTerminal: '卸货机场货站',
      sailingSchedule: '开航航班期',
      flightSchedule: '航班表',
      transportationTime: '航程',
      transportationDays: '航程（天）',
      transportationMode: '运输方式',
      arrivalNodeType: '到达/卸货节点',
      segmentTruck: '卡车',
      segmentBarge: '驳船',
      segmentRail: '铁路',
      seaPort: '海港',
      railwayStation: '铁路站',
      airport: '机场',
      departureAirport: '出发机场',
      arrivalAirport: '到达机场',
      loadingStation: '装货铁路站',
      destinationStation: '目的铁路站',
      destinationArea: '目的地区域',
      segmentRouteInfo: '分段路线信息',
      directTruck: '直拖',
      feeder: '支线',
      seaRail: '海铁',
      monday: '周一',
      tuesday: '周二',
      wednesday: '周三',
      thursday: '周四',
      friday: '周五',
      saturday: '周六',
      sunday: '周日',
      weekdaySeparator: '、',
      customsCutoffTime: '截关时间',
      weightCutoffTime: '截重时间',
      timelinessAchievementRate: '时效达成率',
      carrierPromiseDays: '承诺全程时效',
      airlinePromiseDays: '承运商承诺全程时效',
      pickupLeadTime: '前置提货时长',
      portToPortDays: '港到港时效',
      clearanceDeliveryDays: '清派时效',
      routeCode: '航线代码',
      aircraftType: '机型',
      cabinVolume: '舱位体积',
      freeStorageDays: '目的机场免存期',
      freeCfsStorageDays: 'CFS仓库免存期',
      securityRequired: '货物安检要求',
      securityRequirement: '安检说明',
      specialCargoRequired: '特殊货物运输',
      specialCargoDescription: '特殊货物说明',
      yes: '是',
      no: '否',
      daysValue: '{days}天'
    },

    // 路由模式
    routeMode: '路由模式',
    direct: '直达',
    transshipment: '中转',
    transshipmentPorts: '中转港',
    transshipmentPort1: '第1中转港',
    transshipmentPort2: '第2中转港',
    transshipmentPort3: '第3中转港',
    validation: {
      transshipmentPortRequired: '中转模式下至少需要选择一个中转港'
    },

    // 供应商备注
    supplierRemarks: '供应商备注',
    supplierRemarksPlaceholder: '请输入供应商备注',
    noRemarks: '暂无备注',

    // 按钮操作
    edit: '编辑',
    cancel: '取消',
    save: '保存',
    submit: '提交',
    confirmConsultation: '磋商完成',
    confirmSupplier: '确认供应商',
    cancelConfirmSupplier: '取消确认供应商',

    // AI识别
    aiRecognition: {
      buttonText: 'AI识别',
      modalTitle: 'AI智能识别',
      inputLabel: '请粘贴供应商报价文本内容',
      placeholder: '请粘贴供应商报价内容，AI将自动识别并提取报价明细、航程信息等...',
      tip: '支持识别供应商报价单中的计费项目、单价、数量、币种等信息，以及船期、航次、运输天数等航程信息',
      okText: '开始识别',
      inputRequired: '请输入要识别的文本内容',
      emptyResult: '未能识别出有效信息，请检查输入内容',
      success: 'AI识别成功，信息已自动填充',
      failed: 'AI识别失败，请稍后重试'
    },

    quotationPlans: {
      title: '报价方案',
      add: '添加方案',
      copy: '复制方案',
      prefix: '方案',
      onePrice: 'All In 价格',
      direct: '直达',
      transit: '中转',
      unspecified: '不指定'
    },

    // 提示消息
    messages: {
      missingQuotationId: '缺少报价单ID',
      loadDataError: '加载数据失败',
      anonymousLinkInvalid: '报价链接无效或已过期，请联系询价方重新发送',
      anonymousLoadFailed: '报价数据加载失败，请稍后重试',
      addItemSuccess: '已添加新的报价明细行,请填写相关信息',
      deleteConfirmTitle: '确认删除',
      deleteConfirmContent: '确定要删除这条报价明细吗?',
      deleteSuccess: '删除成功',
      consultationContentRequired: '请输入磋商内容',
      consultationSubmitSuccess: '磋商提交成功',
      consultationSubmitError: '提交磋商失败',
      noConsultationRecords: '暂无磋商记录',
      noChargingItems: '暂无计费项',
      saveSuccess: '保存成功',
      saveError: '保存失败',
      submitSuccess: '提交成功',
      submitError: '提交失败',
      cancelConfirmTitle: '确认取消',
      cancelConfirmContent: '确定要取消编辑吗？未保存的修改将丢失',
      consultationSuccess: '磋商成功',
      consultationFailed: '磋商失败',
      quotationExpiredTitle: '报价已截止',
      quotationExpiredContent: '该报价截止日期已过，当前仅可查看，无法编辑或提交。',
      quotationExpiredEdit: '报价已截止，无法编辑',
      quotationExpiredSubmit: '报价已截止，无法提交',
      quotationConfirmedLocked: '报价已确认供应商，不允许再次编辑或磋商',
      consultationAlreadyCompleted: '本次磋商已完成，需客户发起下一次磋商后才可修改',
      selectTransferPort: '请选择中转港',
      selectCarrier: '请选择{carrier}',
      typeNotSupportEdit: '当前报价类型暂不支持编辑',
      validPeriodRequired: '请选择报价有效期',
      destinationCountryInvalid: '目的国家资料不完整，请刷新后重试',
      validPeriodInvalid: '报价有效期开始日期不能晚于结束日期',
      feeRequired: '请至少填写一条有效费用',
      trunkFeeRequired: '请至少完整填写一条{group}',
      segmentFeeRequired: '请至少完整填写一条{group}',
      emptyFeeGroup: '暂无{group}',
      addFeeGroup: '新增{group}',
      feeFieldRequired: '{group} 第 {index} 条费用请填写{field}',
      feeMinMaxNonNegative: '{group} 第 {index} 条费用的最低收费和最高收费不能小于 0',
      feeMaxLessThanMin: '{group} 第 {index} 条费用的最高收费不能小于最低收费',
      containerPriceRequired: '{group} 第 {index} 条费用请至少填写一个箱型价格',
      feeGroupMismatch: '费用项 {fee} 不属于 {group}，请重新选择',
      requiredFeeMissing: '必填费用项【{fee}】未填写',
      requiredFeeDeleteDisabled: '必填费用项不可删除',
      planCreateSuccess: '报价方案已新增',
      planCreateFailed: '新增报价方案失败',
      planCopySuccess: '报价方案已复制',
      planCopyFailed: '复制报价方案失败',
      planSwitchUnsaved: '请先保存或取消当前编辑后再切换方案',
      planDeleteConfirm: '确定删除该报价方案吗?',
      planDeleteSuccess: '报价方案已删除',
      planDeleteFailed: '删除报价方案失败',
      securityRequirementRequired: '货物安检要求为“是”时，请填写安检说明',
      specialCargoDescriptionRequired: '特殊货物运输为“是”时，请填写特殊货物说明',
      etaBeforeEtd: '预计到达时间不能早于预计出发时间',
      serviceFieldRequired: '请填写{field}'
    },

    feeGroups: {
      basic: '基础费用',
      oceanFreight: '海运费',
      airFreight: '空运费',
      fixed: '基础运费',
      prePort: '港前费用',
      prePortSurcharge: '港前附加费',
      origin: '起运港费用',
      destination: '目的港费用',
      lastMile: '尾程费用',
      lastMileSurcharge: '尾程附加费',
      surcharge: '附加费',
      potential: '潜在费用'
    },

    feeFields: {
      project: '费用名称',
      potentialFeeType: '费用类型',
      measureId: '单位',
      densityDegree: '密度等级',
      calcType: '计算方式',
      quantity: '数量',
      billingQuantity: '计费数量',
      unitRate: '单价',
      currency: '币种',
      prepaidCollect: '预付/到付',
      weightBreak: '重量段',
      minCharge: '最低收费',
      maxCharge: '最高收费',
      amount: '金额',
      remarks: '备注'
    },

    airRate: {
      unitPrice: '单价',
      weightRate: '单价（计重）',
      densityGroup: '密度组 {index}',
      selectDensityDegree: '选择密度等级范围',
      selectCarrierFirst: '请先选择航空公司',
      type: '类型',
      rate: '费率',
      billingTerm: '计费条款',
      minimumConsumption: '最低收费(M)',
      normalRate: '普通价格(N)',
      addDensityGroup: '添加密度等级组'
    },

    potentialFeeTypes: {
      seaSurcharge: '海运附加费',
      airSurcharge: '空运附加费',
      seaOrigin: '起运港费用',
      seaDestination: '目的港费用',
      airOrigin: '起飞地费用',
      airDestination: '目的地费用',
      prePortSurcharge: '港前附加费',
      lastMileSurcharge: '尾程附加费'
    },

    calcTypes: {
      perCbm: '按体积(CBM)',
      perTon: '按吨(MT)',
      perPackage: '按件',
      perBill: '按票',
      flat: '固定费用'
    },

    // 箱型名称
    containerTypes: {
      gp20: '20GP',
      gp40: '40GP',
      hc20: '20HC',
      hc40: '40HC',
      hc45: '45HC',
      nor20: '20NOR',
      nor40: '40NOR',
      tk20: '20TK',
      tk40: '40TK',
      ot20: '20OT',
      ot40: '40OT',
      fr20: '20FR',
      fr40: '40FR'
    }
  },

  supplierExpressQuotation: {
    title: '快递报价详情',
    titles: {
      EXPRESS: '快递报价',
      LTL: '零担报价',
      FTL: '整车报价'
    },
    planCount: '共 {count} 个方案',
    planTitle: '方案 {index}',
    emptyPlans: '暂无报价方案',
    emptySurcharges: '暂无附加费',
    sections: {
      inquiry: '询价信息',
      plans: '报价方案',
      currentPlan: '当前方案',
      quotationDetail: '报价明细',
      consultationHistory: '磋商记录',
      basic: '基础信息',
      origin: '发货地',
      destination: '目的地',
      cargo: '货物信息',
      baseFee: '基础费用',
      billing: '计费规则',
      billingDetail: '计费明细',
      totalFee: '综合费用',
      onePrice: '一口价',
      weightTiers: '重量段阶梯',
      surcharges: '附加费',
      ltlFees: '附加费',
      vehicle: '车辆信息',
      remarks: '备注信息'
    },
    fields: {
      quotationNo: '报价编号',
      inquiryNo: '询价编号',
      quoter: '报价人',
      inquiryNature: '询价性质',
      palletNature: '货盘性质',
      cargoReadyTime: '货好时间',
      transportTerms: '运输条款',
      tradeTerms: '贸易条款',
      inquiryEnterprise: '询价企业',
      directTransit: '直达/中转',
      expressCarrier: '快递公司',
      loadMode: '装载模式',
      serviceType: '服务类型',
      cargoType: '货物类型',
      origin: '发货地',
      destination: '收货地',
      weight: '重量',
      actualWeight: '实际总重量(KGS)',
      actualTotalWeight: '实际总重量(KGS)',
      totalWeight: '货物总重量(KGS)',
      cubage: '体积',
      totalCubage: '总体积(CBM)',
      quantity: '件数',
      remarks: '备注',
      files: '附件',
      summaryQuantity: '总件数',
      summaryWeight: '总毛重',
      summaryVolume: '总体积',
      shipperRemarks: '货主备注',
      supplierRemarks: '说明事项',
      dimensions: '单件尺寸',
      cargoDescription: '货物描述',
      expectedSailingTime: '期望开航时间',
      expectedTransitTime: '期望到达时效',
      unNo: 'UN 编号',
      cargoCategory: '类别',
      cargoName: '品名',
      hsCode: 'HSCODE',
      cargoValue: '货值',
      quoteDeadline: '报价截止时间',
      specialRequirements: '特殊要求',
      country: '国家',
      province: '州/省',
      city: '市',
      district: '区/县',
      street: '乡/镇/街道',
      detailAddress: '详细地址',
      postalCode: '邮编',
      warehouse: '仓库',
      lengthCm: '长(CM)',
      widthCm: '宽(CM)',
      heightCm: '高(CM)',
      lengthM: '长(M)',
      widthM: '宽(M)',
      heightM: '高(M)',
      needPickup: '是否需要提货',
      needDelivery: '是否需要送货',
      needUpstairs: '是否需要上楼',
      needLoadingUnloading: '是否需要装卸',
      expectedVehicleType: '期望车型',
      pricingPreference: '计费方式偏好',
      validPeriod: '有效期',
      billingModel: '计费模型',
      billingMethod: '计费方式',
      currency: '币种',
      paymentTerm: '付费条款',
      volumetricFactor: '体积重系数',
      isOnePrice: '是否一口价',
      firstWeightThreshold: '首重重量',
      firstWeightThresholdKg: '首重阈值(KG)',
      firstWeightPrice: '首重价格',
      additionalWeightUnit: '续重单位',
      additionalWeightUnitKg: '续重单位(KG)',
      additionalWeightPrice: '续重价格',
      weightTierAdditionalWeightPrice: '续重单价',
      weightTierMinCharge: '最低收费（总价）',
      minCharge: '最低收费',
      minBillingWeight: '最小计费重量',
      pickupFee: '提货费',
      deliveryFee: '送货费',
      loadingFee: '装卸费',
      unitPrice: '单价',
      unitPriceKg: '单价(KG)',
      unitPriceCbm: '单价(CBM)',
      unitPriceTicket: '单价(票)',
      unitPricePiece: '单价(件)',
      tripPrice: '整车一口价',
      kmPrice: '每公里单价',
      minKm: '最低里程',
      vehicleType: '车型',
      vehicleCapacity: '车型载重(吨)',
      vehicleVolume: '车型容积(m³)',
      weightStart: '起始重量',
      weightStartKg: '起始重量(KG)',
      weightEnd: '结束重量',
      weightEndKg: '结束重量(KG)',
      chargeName: '费用名称',
      surchargeBillingMode: '计费模式',
      measure: '单位',
      unitRate: '单价/费率',
      fixedAmount: '固定金额',
      amount: '金额',
      baseCost: '基础费用',
      onePrice: '一口价',
      totalPrice: '总价',
      onePriceAmount: '一口价总价',
      onePriceCurrency: '一口价币种',
      onePriceIncludedItems: '包含项目',
      onePriceRemarks: '一口价备注',
      prepaidCollect: '预付/到付',
      prepaid: '预付',
      collect: '到付',
      isCountTotal: '计入总价',
      isTotalIncluded: '已包含',
      totalAmount: '总计金额',
      totalAmountByCurrency: '分币种合计',
      currentVersion: '当前版本',
      changeContent: '变更内容',
      consultationRemarks: '磋商备注'
    },
    actions: {
      addPlan: '新增方案',
      deletePlan: '删除方案',
      addRow: '新增行',
      deleteRow: '删除',
      addSurcharge: '新增附加费',
      saveDraft: '保存草稿',
      submit: '提交报价',
      cancel: '取消',
      consultationComplete: '磋商完成'
    },
    placeholders: {
      input: '请输入',
      select: '请选择',
      optional: '选填',
      unlimited: '留空表示无上限',
      onePriceIncludedItems: '必填，请说明一口价包含的费用项目，如：基础运费、港口费用、附加费等',
      onePriceRemarks: '请说明一口价包含的具体费用范围、条件或其他说明...'
    },
    enums: {
      status: {
        draft: '草稿',
        submitted: '已提交',
        imported: '已导入'
      },
      surchargeBillingMode: {
        FIRST_ADDITIONAL: '首重+续重',
        UNIT_PRICE: '单价计费',
        FIXED: '固定费用',
        PERCENTAGE: '百分比费用'
      },
      boolean: {
        yes: '是',
        no: '否'
      },
      consultationStatus: {
        notConsulted: '未磋商',
        inProgress: '磋商中',
        completed: '磋商完成'
      },
      palletNature: {
        inquiry: '询价',
        actual: '实单'
      },
      cargoReadyTimeRange: {
        1: '一周内',
        2: '二周内',
        3: '一个月内',
        4: '一个月以上',
        5: '时间未知'
      },
      directTransit: {
        direct: '直达',
        transit: '中转',
        unspecified: '不指定'
      }
    },
    consultationRecords: {
      expectedPrice: '期望价格',
      note: '磋商说明',
      status: '状态',
      changeContent: '报价变更',
      consulting: '磋商中',
      replied: '已回复',
      currentRound: '当前轮次',
      changeAdded: '新增 {project}：{amount}',
      changeRemoved: '删除 {project}，原价格 {amount}',
      changeAdjusted: '{project}由 {oldAmount} 调整为 {newAmount}',
      changeReplaced: '{oldProject} {oldAmount} 调整为 {newProject} {newAmount}',
      projects: {
        price: '价格',
        onePrice: '一口价',
        firstWeight: '首重价格（{weight} KG）',
        additionalWeight: '续重价格（{weight} KG）',
        minCharge: '最低收费',
        unitPrice: '单价',
        tripPrice: '整车一口价',
        kmPrice: '每公里单价',
        weightTier: '重量段 {start}-{end} KG {metric}',
        surcharge: '附加费“{name}”{metric}',
        firstWeightPrice: '首重价格',
        additionalWeightPrice: '续重价格'
      }
    },
    calculationWarnings: {
      CONTEXT_REQUIRED: '缺少计算上下文，暂时无法计算总价',
      WEIGHT_REQUIRED: '缺少有效计费重量，暂时无法计算总价',
      SIZE_REQUIRED: '缺少完整货物尺寸，暂时无法计算体积重',
      PIECES_REQUIRED: '缺少有效件数，暂时无法计算体积重',
      VOLUME_REQUIRED: '缺少有效体积，暂时无法计算总价',
      PRICE_DETAIL_REQUIRED: '报价计费明细不完整，暂时无法计算总价',
      WEIGHT_TIER_NOT_MATCHED: '计费重量未匹配任何重量段，暂时无法计算总价',
      SURCHARGE_MEASURE_REQUIRED: '附加费计费单位无法识别，暂时无法计算总价',
      SURCHARGE_PERCENTAGE_INVALID: '燃油附加费百分比必须在 0 至 100 之间',
      SURCHARGE_PERCENTAGE_NOT_ALLOWED: '非燃油附加费不能使用百分比计费'
    },
    messages: {
      missingId: '缺少报价ID',
      tokenInvalid: '报价链接无效或已过期',
      loadFailed: '快递报价加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      planCreated: '方案已新增',
      planCreateFailed: '新增方案失败',
      deletePlanTitle: '删除方案',
      deletePlanContent: '确定删除当前报价方案吗？删除后不可恢复。',
      planDeleteSuccess: '方案已删除',
      planDeleteFailed: '删除方案失败',
      noChange: '暂无变更内容',
      noConsultationRecords: '暂无磋商记录',
      requiredField: '请填写/选择{field}',
      validPeriodInvalid: '有效期结束时间不能早于开始时间',
      weightTierMissing: '请至少填写一条重量段阶梯',
      weightTierRequired: '请完整填写第 {index} 行重量段，价格必须为有效非负数',
      weightTierPriceModeInvalid: '第 {index} 行只能填写单价（续重单价可选）或最低收费（总价），未使用的价格字段必须留空',
      weightTierRangeInvalid: '第 {index} 行重量段结束重量必须大于起始重量',
      weightTierOpenEndedLast: '无上限重量段只能放在最后一行',
      surchargeRequired: '请完整填写第 {index} 条附加费的费用名称、计费模式、单位、币种和付费条款',
      surchargeFirstAdditionalRequired: '请完整填写第 {index} 条附加费的首重续重字段',
      surchargeAmountRequired: '请填写第 {index} 条附加费的单价/费率',
      surchargePercentageRange: '第 {index} 条附加费的百分比必须在 0 至 100 之间',
      surchargeAtLeastOne: '附加费至少需要填写一条',
      onePriceAmountRequired: '请填写一口价总价',
      onePriceCurrencyRequired: '请选择一口价币种',
      onePriceIncludedItemsRequired: '请填写一口价包含项目',
      planHasRequiredField: '方案 {index} 存在必填字段未填写'
    }
  },

  supplierFclQuotation: {
    title: '海运报价详情',
    inquiryTitle: '海运询价单',
    planCount: '共 {count} 个方案',
    planTitle: '方案 {index}',
    emptyPlans: '暂无报价方案',
    emptyFees: '暂无费用',
    quotationNotExist: '报价方案不存在',
    sections: {
      quotationDetail: '报价明细',
      consultationHistory: '磋商记录',
      basic: '基础信息',
      cargo: '货物信息',
      plans: '报价方案',
      prePort: '港前',
      sea: '海运',
      lastMile: '尾程',
      other: '其他',
      baseFee: '基础费用',
      baseOceanFee: '基础海运费',
      surcharge: '附加费',
      oceanSurcharge: '海运附加费',
      originPortFee: '起运港费用',
      destinationPortFee: '目的港费用',
      potentialFee: '潜在费用',
      files: '附件',
      remarks: '备注'
    },
    fields: {
      inquiryNo: '询价编号',
      quotationNo: '报价编号',
      carrier: '船公司',
      loadingCountry: '起运国',
      loadingCity: '起运城市',
      loadingPort: '起运港',
      destinationCountry: '目的国',
      destinationCity: '目的城市',
      destinationPort: '目的港',
      directTransit: '直达/中转',
      direct: '直达',
      transit: '中转',
      cargoReadyTime: '货好时间',
      cargoType: '货物类型',
      unNo: 'UN 编号',
      hazardClass: '类别',
      cargoName: '品名',
      hsCode: 'HSCODE',
      cargoValue: '货值(币种)',
      onePrice: '一口价',
      quotationDeadline: '报价截止时间',
      specialRequirements: '特殊要求',
      serviceType: '服务类型',
      containerType: '箱型',
      containerNum: '箱量',
      quantityPerContainer: '每箱件数',
      weightPerContainer: '每箱毛重',
      lengthPerContainer: '每箱长',
      widthPerContainer: '每箱宽',
      heightPerContainer: '每箱高',
      totalQuantity: '总件数',
      totalWeight: '总毛重',
      totalVolume: '总体积',
      summaryQuantity: '总件数',
      summaryWeight: '总毛重',
      summaryVolume: '总体积',
      temperatureRange: '温度范围',
      ventilationDoor: '通风门',
      ventilationQuantity: '风量',
      humidity: '湿度',
      needPrecooling: '是否预冷',
      remarks: '备注',
      packageType: '包装类型',
      quantity: '件数',
      weight: '毛重(KGS)',
      length: '长(CM)',
      width: '宽(CM)',
      height: '高(CM)',
      lengthM: '长(M)',
      widthM: '宽(M)',
      heightM: '高(M)',
      // RORO fields
      transportCategory: '运输品类',
      vehicleType: '车辆类型',
      vehicleBrand: '品牌',
      vehicleModel: '型号',
      equipmentName: '设备名称',
      isCrawler: '是否履带式',
      isSelfPropelled: '是否自行移动',
      isOversized: '是否超限',
      canDeckLoad: '能否甲板装载',
      specialFixingRequirement: '特殊固定要求',
      outerLength: '外长(CM)',
      outerWidth: '外宽(CM)',
      outerHeight: '外高(CM)',
      grossWeight: '毛重(KGS)',
      // BULK fields
      bulkCargoName: '货物名称',
      stowageFactor: '积载因数',
      liftingRequirement: '吊装要求',
      unitWeight: '单件毛重(KGS)',
      unitLength: '单件长(CM)',
      unitWidth: '单件宽(CM)',
      unitHeight: '单件高(CM)',
      isOnePrice: '是否一口价',
      validPeriod: '价格有效期',
      pPickupPort: '装货港',
      pCarrier: '船公司',
      pVessel: '驳船船名',
      pVoyage: '驳船航次',
      pBargeEtd: '驳船开航时间',
      pBargeEta: '驳船到港时间',
      pTransportationDays: '驳船航程',
      pPickupRailwayStation: '装货站',
      pRailCompany: '铁路公司',
      pRailLineType: '线路分类',
      pRailTrainNo: '车次',
      pRailDepartureTime: '发车时间',
      pLoadingPort: '起运港',
      pStuffingTerminal: '起运码头',
      pLoadingRailwayStation: '起运站',
      pLoadingAirport: '起运机场',
      pLoadingAirportTerminal: '机场货站',
      dischargePort: '目的港',
      transferPort: '中转港',
      vessel: '船名',
      voyage: '航次',
      etd: 'ETD',
      eta: 'ETA',
      transportationDays: '航程',
      weekdays: '开航班期',
      demurrage: '滞港费',
      detention: '滞箱费',
      overweight: '限重',
      lDischargingPort: '卸货港',
      lDeliveryTerminal: '卸货码头',
      lDischargingStation: '卸货站',
      lDischargingAirport: '卸货机场',
      lAirportCargoTerminal: '机场货站',
      lDestinationPort: '目的地',
      lVessel: '驳船船名',
      lVoyage: '驳船航次',
      lBargeEtd: '驳船开航时间',
      lBargeEta: '驳船到港时间',
      lTransportationDays: '驳船航程',
      lDestinationStation: '目的站',
      lRailCompany: '铁路公司',
      lRailLineType: '线路分类',
      lRailTrainNo: '车次',
      lRailDepartureTime: '发车时间',
      feeName: '费用名称',
      feeType: '费用类型',
      measure: '单位',
      containerTypeAndNum: '箱型箱量',
      unitRate: '单价',
      currency: '币种',
      paymentTerm: '付费条款',
      files: '附件',
      totalAmountByCurrency: '分币种合计',
      currentVersion: '当前版本',
      contactPhone: '电话',
      contactEmail: '邮箱'
    },
    actions: {
      addPlan: '新增方案',
      deletePlan: '删除方案',
      addSurcharge: '新增附加费',
      addPotentialFee: '新增潜在费用',
      addOriginPortFee: '新增起运港费用',
      addDestinationPortFee: '新增目的港费用',
      addOceanSurcharge: '新增海运附加费',
      addBaseFee: '新增基础费用',
      addOceanFreight: '新增基础海运费',
      save: '保存',
      submit: '提交',
      initiateConsultation: '发起磋商',
      consultationContent: '磋商内容',
      consultationContentPlaceholder: '请输入磋商内容',
      cancel: '取消',
      consultationComplete: '磋商完成',
      confirm: '确定'
    },
    placeholders: {
      input: '请输入',
      select: '请选择',
      search: '搜索',
      selectDate: '请选择日期'
    },
    messages: {
      loadFailed: '报价数据加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      planCreated: '方案创建成功',
      planCreateFailed: '方案创建失败',
      planDeleteSuccess: '方案删除成功',
      planDeleteFailed: '方案删除失败',
      deletePlanTitle: '确认删除',
      deletePlanContent: '确定要删除当前报价方案吗？',
      tokenInvalid: '链接无效或已失效',
      quotationExpired: '报价已截止',
      missingId: '缺少报价方案 ID',
      requiredField: '请填写 {field}',
      validPeriodRequired: '请填写价格有效期',
      duplicateFeeName: '费用名称不允许重复',
      planHasRequiredField: '方案{index}存在必填字段未填写',
      initiateConsultationSuccess: '发起磋商成功',
      initiateConsultationFailed: '发起磋商失败',
      consultationContentRequired: '请输入磋商内容'
    },
    consultationRecords: {
      currentVersion: '当前版本',
      expectedPrice: '期望价格',
      note: '备注',
      status: '状态',
      consulting: '磋商中',
      replied: '已回复',
      changeContent: '变更内容',
      messages: {
        noChange: '本次无变更',
        noConsultationRecords: '暂无磋商记录'
      },
      feeCategories: {
        PRE_PORT_BASE: '港前-基础费用',
        PRE_PORT_SURCHARGE: '港前-附加费',
        PRE_PORT_POTENTIAL: '港前-潜在费用',
        SEA_BASE: '海运-基础海运费',
        SEA_SURCHARGE: '海运-附加费',
        SEA_ORIGIN_PORT: '海运-起运港费用',
        SEA_DEST_PORT: '海运-目的港费用',
        SEA_POTENTIAL: '海运-潜在费用',
        LAST_MILE_BASE: '尾程-基础费用',
        LAST_MILE_SURCHARGE: '尾程-附加费',
        LAST_MILE_POTENTIAL: '尾程-潜在费用'
      },
      changeTypes: {
        added: '新增',
        removed: '删除',
        adjusted: '调整'
      }
    },
    enums: {
      serviceType: {
        FCL: '整箱',
        LCL: '拼箱',
        RORO: '滚装',
        BULK: '散杂货'
      },
      transportCategory: {
        1: '各类车辆',
        2: '轮式/履带设备',
        3: '滚装托盘/单元货',
        4: '加装行走轮大件构件'
      },
      paymentTerm: {
        PREPAID: '预付',
        COLLECT: '到付'
      },
      potentialFeeType: {
        SEA_SURCHARGE: '海运附加费',
        ORIGIN_PORT: '起运港费用',
        DEST_PORT: '目的港费用'
      },
      consultationStatus: {
        1: '未磋商',
        2: '磋商中',
        3: '磋商完成'
      }
    }
  },

  supplierAirQuotation: {
    title: '空运报价详情',
    inquiryTitle: '空运询价单',
    planCount: '共 {count} 个方案',
    planTitle: '方案 {index}',
    emptyPlans: '暂无报价方案',
    emptyFees: '暂无费用',
    quotationNotExist: '报价方案不存在',
    sections: {
      quotationDetail: '报价明细',
      consultationHistory: '磋商记录',
      basic: '基础信息',
      cargo: '货物信息',
      plans: '报价方案',
      prePort: '港前',
      air: '空运',
      lastMile: '尾程',
      other: '其他',
      baseFee: '基础费用',
      surcharge: '附加费',
      originFee: '起飞地费用',
      destFee: '目的地费用',
      potentialFee: '潜在费用',
      files: '附件',
      remarks: '备注'
    },
    fields: {
      quotationNo: '报价编号',
      inquiryNature: '询价性质',
      paymentMethod: '付款方式',
      transportClause: '运输条款',
      serviceTerm: '贸易条款',
      carrier: '航空公司',
      loadingCountry: '起运国',
      loadingCity: '起运城市',
      loadingAirport: '起运机场',
      destinationCountry: '目的国',
      destinationCity: '目的城市',
      destinationAirport: '目的机场',
      directTransit: '直达/中转',
      cargoReadyTime: '货好时间',
      expectedSailingTime: '期望开航时间',
      cargoType: '货物类型',
      unNo: 'UN 编号',
      hazardClass: '类别',
      cargoName: '品名',
      hsCode: 'HSCODE',
      cargoValue: '货值',
      onePrice: '一口价',
      quotationDeadline: '报价截止时间',
      specialRequirements: '特殊要求',
      serviceType: '服务类型',
      // 货物信息字段
      airPalletType: '航空板型',
      palletCount: '板数',
      quantity: '件数',
      weight: '毛重(KGS)',
      length: '长(CM)',
      width: '宽(CM)',
      height: '高(CM)',
      lengthM: '长(M)',
      widthM: '宽(M)',
      heightM: '高(M)',
      packageType: '包装方式',
      temperatureRange: '温度范围',
      ventilationDoor: '通风门',
      ventilationQuantity: '风量',
      humidity: '湿度',
      needPrecooling: '是否预冷',
      totalQuantity: '总件数',
      totalWeight: '总毛重',
      totalVolume: '总体积',
      summaryQuantity: '总件数',
      summaryWeight: '总毛重',
      summaryVolume: '总体积',
      remarks: '备注',
      containerEquipment: '集装设备',
      exclusiveCargoHold: '是否独占货舱',
      handlingRequirement: '装卸要求',
      preferredAircraftType: '偏好机型',
      singleBoardQuantity: '单板件数',
      singleBoardWeight: '单板毛重',
      singleBoardLength: '单板长',
      singleBoardWidth: '单板宽',
      singleBoardHeight: '单板高',
      singlePieceQuantity: '单种件数',
      singlePieceWeight: '单件毛重',
      singlePieceLength: '单件长',
      singlePieceWidth: '单件宽',
      singlePieceHeight: '单件高',
      maxPieceLength: '单件最大长',
      maxPieceWidth: '单件最大宽',
      maxPieceHeight: '单件最大高',
      // 空运段字段
      flightNo: '航班号',
      transitAirport: '中转机场',
      flightDepartureTime: '起飞时间',
      flightArrivalTime: '落地时间',
      weekdays: '班期',
      routeLevel: '航线等级',
      // 港前字段
      pPickupPort: '装货港',
      pCarrier: '船公司',
      pVessel: '驳船船名',
      pVoyage: '驳船航次',
      pBargeEtd: '驳船开航时间',
      pBargeEta: '驳船到港时间',
      pTransportationDays: '驳船航程',
      pPickupRailwayStation: '装货站',
      pRailCompany: '铁路公司',
      pRailLineType: '线路分类',
      pRailTrainNo: '车次',
      pRailDepartureTime: '发车时间',
      pLoadingPort: '起运港',
      pStuffingTerminal: '起运码头',
      pLoadingRailwayStation: '起运站',
      pLoadingAirport: '起运机场',
      pAirportTerminal: '机场货站',
      // 尾程字段
      lDischargingPort: '卸货港',
      lDeliveryTerminal: '卸货码头',
      lDischargingStation: '卸货站',
      lDischargingAirport: '卸货机场',
      lAirportTerminal: '机场货站',
      lDestinationPort: '目的地',
      lVessel: '驳船船名',
      lVoyage: '驳船航次',
      lBargeEtd: '驳船开航时间',
      lBargeEta: '驳船到港时间',
      lTransportationDays: '驳船航程',
      lDestinationStation: '目的站',
      lRailCompany: '铁路公司',
      lRailLineType: '线路分类',
      lRailTrainNo: '车次',
      lRailDepartureTime: '发车时间',
      // 费用字段
      feeName: '费用名称',
      feeType: '费用类型',
      measure: '单位',
      unitRate: '单价',
      currency: '币种',
      paymentTerm: '付费条款',
      densityLevel: '密度等级',
      hitDensityLevel: '命中密度等级',
      hitWeightSection: '命中重量段',
      tierM: 'M',
      tierN: 'N',
      tier45: '45+',
      tier100: '100+',
      tier300: '300+',
      tier500: '500+',
      tier700: '700+',
      tier1000: '1000+',
      tier2000: '2000+',
      files: '附件',
      totalAmountByCurrency: '分币种合计',
      contactPhone: '电话',
      contactEmail: '邮箱',
      validPeriod: '价格有效期',
      supplierRemarks: '说明事项'
    },
    actions: {
      addPlan: '新增方案',
      deletePlan: '删除方案',
      addBaseFee: '新增基础费用',
      addSurcharge: '新增附加费',
      addOriginFee: '新增起飞地费用',
      addDestFee: '新增目的地费用',
      addPotentialFee: '新增潜在费用',
      save: '保存',
      submit: '提交',
      initiateConsultation: '发起磋商',
      consultationContent: '磋商内容',
      consultationContentPlaceholder: '请输入磋商内容',
      cancel: '取消',
      consultationComplete: '磋商完成',
      confirm: '确定'
    },
    placeholders: {
      input: '请输入',
      select: '请选择',
      search: '搜索',
      selectDate: '请选择日期'
    },
    messages: {
      loadFailed: '报价数据加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      planCreated: '方案创建成功',
      planCreateFailed: '方案创建失败',
      planDeleteSuccess: '方案删除成功',
      planDeleteFailed: '方案删除失败',
      deletePlanTitle: '确认删除',
      deletePlanContent: '确定要删除当前报价方案吗？',
      tokenInvalid: '链接无效或已失效',
      quotationExpired: '报价已截止',
      missingId: '缺少报价方案 ID',
      requiredField: '请填写 {field}',
      validPeriodRequired: '请填写价格有效期',
      duplicateFeeName: '费用名称不允许重复',
      planHasRequiredField: '方案{index}存在必填字段未填写',
      initiateConsultationSuccess: '发起磋商成功',
      initiateConsultationFailed: '发起磋商失败',
      consultationContentRequired: '请输入磋商内容'
    },
    consultationRecords: {
      currentVersion: '当前版本',
      expectedPrice: '期望价格',
      note: '备注',
      status: '状态',
      consulting: '磋商中',
      replied: '已回复',
      changeContent: '变更内容',
      noChange: '无变化',
      messages: {
        noChange: '本次无变更',
        noConsultationRecords: '暂无磋商记录'
      },
      feeCategories: {
        PRE_PORT_BASE: '港前-基础费用',
        PRE_PORT_SURCHARGE: '港前-附加费',
        PRE_PORT_POTENTIAL: '港前-潜在费用',
        AIR_BASE: '空运-基础费用',
        AIR_SURCHARGE: '空运-附加费',
        AIR_ORIGIN: '空运-起飞地费用',
        AIR_DEST: '空运-目的地费用',
        AIR_POTENTIAL: '空运-潜在费用',
        LAST_MILE_BASE: '尾程-基础费用',
        LAST_MILE_SURCHARGE: '尾程-附加费',
        LAST_MILE_POTENTIAL: '尾程-潜在费用'
      },
      changeTypes: {
        added: '新增',
        removed: '删除',
        adjusted: '调整'
      }
    },
    enums: {
      airServiceType: {
        CONSOL: '散货',
        FULL_PALLET: '整板',
        BLOCK_SPACE: '整舱',
        FULL_CHARTER: '包机'
      },
      routeLevel: {
        EXPRESS: '极速',
        STANDARD: '标准',
        ECONOMY: '经济'
      },
      airPotentialFeeType: {
        ORIGIN: '起飞地费用',
        DEST: '目的地费用',
        SURCHARGE: '空运附加费'
      },
      paymentTerm: {
        PREPAID: '预付',
        COLLECT: '到付'
      },
      consultationStatus: {
        1: '未磋商',
        2: '磋商中',
        3: '磋商完成'
      }
    }
  },

  supplierRailQuotation: {
    title: '铁路报价详情',
    inquiryTitle: '铁路询价单',
    planCount: '共 {count} 个方案',
    planTitle: '方案 {index}',
    emptyPlans: '暂无报价方案',
    emptyFees: '暂无费用',
    quotationNotExist: '报价方案不存在',
    sections: {
      quotationDetail: '报价明细',
      consultationHistory: '磋商记录',
      basic: '基础信息',
      cargo: '货物信息',
      plans: '报价方案',
      prePort: '港前',
      rail: '铁路',
      lastMile: '尾程',
      baseFee: '基础费用',
      surcharge: '附加费',
      potentialFee: '潜在费用',
      files: '附件',
      remarks: '备注',
      containerBasicFee: '集装箱基础费用',
      truckBasicFee: '整车基础费用',
      bulkBasicFee: '散货基础费用'
    },
    fields: {
      quotationNo: '报价编号',
      carrier: '铁路公司',
      loadingCountry: '起运国',
      loadingCity: '起运城市',
      loadingStation: '起运站',
      destinationCountry: '目的国',
      destinationCity: '目的城市',
      destinationStation: '目的站',
      routeType: '线路分类',
      directTransit: '直达/中转',
      direct: '直达',
      transit: '中转',
      transferStation: '中转站',
      cargoReadyTime: '货好时间',
      serviceType: '服务类型',
      cargoType: '货物类型',
      unNo: 'UN 编号',
      hazardClass: '类别',
      cargoName: '品名',
      hsCode: 'HSCODE',
      cargoValue: '货值',
      onePrice: '一口价',
      isOnePrice: '是否一口价',
      quotationDeadline: '报价截止时间',
      specialRequirements: '特殊要求',
      containerType: '箱型',
      containerNum: '箱量',
      quantityPerContainer: '每箱件数',
      weightPerContainer: '每箱毛重',
      lengthPerContainer: '每箱长',
      widthPerContainer: '每箱宽',
      heightPerContainer: '每箱高',
      totalQuantity: '总件数',
      totalWeight: '总毛重',
      totalVolume: '总体积',
      summaryQuantity: '总件数',
      summaryWeight: '总毛重',
      summaryVolume: '总体积',
      temperatureRange: '温度范围',
      ventilationDoor: '通风门',
      ventilationQuantity: '风量',
      humidity: '湿度',
      needPrecooling: '是否预冷',
      vehicleType: '整车类型',
      quantity: '件数',
      weight: '毛重(KGS)',
      length: '长(CM)',
      width: '宽(CM)',
      height: '高(CM)',
      lengthM: '长(M)',
      widthM: '宽(M)',
      heightM: '高(M)',
      packageType: '包装方式',
      remarks: '备注',
      weekdays: '班期',
      trainDepartureTime: '发车时间',
      borderCrossTime: '出境时间',
      trainArrivalTime: '到站时间',
      overweightRemarks: '限重',
      demurrageFreeDays: '免堆存(天)',
      truckType: '车种',
      stdWeight: '标重',
      basePrice1: '基价1',
      basePrice2: '基价2',
      minCharge: '最低收费',
      maxCharge: '最高收费',
      feeName: '费用名称',
      feeType: '费用类型',
      measure: '单位',
      containerTypeAndNum: '箱型箱量',
      unitRate: '单价',
      currency: '币种',
      paymentTerm: '付费条款',
      validPeriod: '价格有效期',
      files: '附件',
      totalAmountByCurrency: '分币种合计',
      contactPhone: '电话',
      contactEmail: '邮箱',
      // 港前字段
      pPickupPort: '装货港',
      pCarrier: '船公司',
      pVessel: '驳船船名',
      pVoyage: '驳船航次',
      pBargeEtd: '驳船开航时间',
      pBargeEta: '驳船到港时间',
      pTransportationDays: '驳船航程',
      pPickupRailwayStation: '装货站',
      pRailCompany: '铁路公司',
      pRailLineType: '线路分类',
      pRailTrainNo: '车次',
      pRailDepartureTime: '发车时间',
      pLoadingPort: '起运港',
      pStuffingTerminal: '起运码头',
      pLoadingRailwayStation: '起运站',
      pLoadingAirport: '起运机场',
      pAirportTerminal: '机场货站',
      // 尾程字段
      lDischargingPort: '卸货港',
      lDeliveryTerminal: '卸货码头',
      lDischargingStation: '卸货站',
      lDischargingAirport: '卸货机场',
      lAirportTerminal: '机场货站',
      lDestinationPort: '目的地',
      lVessel: '驳船船名',
      lVoyage: '驳船航次',
      lBargeEtd: '驳船开航时间',
      lBargeEta: '驳船到港时间',
      lTransportationDays: '驳船航程',
      lDestinationStation: '目的站',
      lRailCompany: '铁路公司',
      lRailLineType: '线路分类',
      lRailTrainNo: '车次',
      lRailDepartureTime: '发车时间'
    },
    actions: {
      addPlan: '新增方案',
      deletePlan: '删除方案',
      addBaseFee: '新增基础费用',
      addSurcharge: '新增附加费',
      addPotentialFee: '新增潜在费用',
      save: '保存',
      submit: '提交',
      initiateConsultation: '发起磋商',
      consultationContent: '磋商内容',
      consultationContentPlaceholder: '请输入磋商内容',
      cancel: '取消',
      consultationComplete: '磋商完成',
      confirm: '确定'
    },
    placeholders: {
      input: '请输入',
      select: '请选择',
      search: '搜索',
      selectDate: '请选择日期'
    },
    messages: {
      loadFailed: '报价数据加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      planCreated: '方案创建成功',
      planCreateFailed: '方案创建失败',
      planDeleteSuccess: '方案删除成功',
      planDeleteFailed: '方案删除失败',
      deletePlanTitle: '确认删除',
      deletePlanContent: '确定要删除当前报价方案吗？',
      tokenInvalid: '链接无效或已失效',
      quotationExpired: '报价已截止',
      requiredField: '请填写 {field}',
      validPeriodRequired: '请填写价格有效期',
      planHasRequiredField: '方案{index}存在必填字段未填写',
      initiateConsultationSuccess: '发起磋商成功',
      initiateConsultationFailed: '发起磋商失败',
      consultationContentRequired: '请输入磋商内容'
    },
    consultationRecords: {
      currentVersion: '当前版本',
      expectedPrice: '期望价格',
      note: '备注',
      status: '状态',
      consulting: '磋商中',
      replied: '已回复',
      changeContent: '变更内容',
      messages: {
        noChange: '本次无变更',
        noConsultationRecords: '暂无磋商记录'
      },
      feeCategories: {
        PRE_PORT_BASE: '港前-基础费用',
        PRE_PORT_SURCHARGE: '港前-附加费',
        PRE_PORT_POTENTIAL: '港前-潜在费用',
        RAIL_BASE: '铁路-基础费用',
        RAIL_SURCHARGE: '铁路-附加费',
        LAST_MILE_BASE: '尾程-基础费用',
        LAST_MILE_SURCHARGE: '尾程-附加费',
        LAST_MILE_POTENTIAL: '尾程-潜在费用'
      },
      changeTypes: {
        added: '新增',
        removed: '删除',
        adjusted: '调整'
      }
    },
    enums: {
      serviceType: {
        CONTAINER: '集装箱',
        TRUCK: '整车',
        BULK: '散货'
      },
      vehicleType: {
        1: '敞车',
        2: '棚车',
        3: '平车',
        4: '冷藏车',
        5: '矿石车',
        6: '水泥车'
      },
      paymentTerm: {
        PREPAID: '预付',
        COLLECT: '到付'
      },
      consultationStatus: {
        1: '未磋商',
        2: '磋商中',
        3: '磋商完成'
      }
    }
  },

  // 港前报价详情页
  supplierPrePortQuotation: {
    title: '港前报价单详情',
    inquiryTitle: '港前询价单',
    planTitle: '方案 {index}',
    emptyPlans: '暂无报价方案',
    emptyFees: '暂无费用',

    fields: {
      quotationNo: '报价编号',
      feeName: '费用名称',
      measure: '单位',
      containerTypeAndNum: '箱型箱量',
      unitRate: '单价',
      currency: '币种',
      paymentTerm: '付费条款',
      remarks: '备注',
      files: '附件',
      transportMode: '运输方式',
      arrivalNodeType: '到达节点',
      totalAmountByCurrency: '分币种合计',
      isOnePrice: '是否一口价',
      validPeriod: '报价有效期',
      serviceType: '服务类型',
      stuffingCity: '装货城市',
      pickupPort: '提货港',
      pickupRailwayStation: '提货站',
      loadingPort: '装货港',
      stuffingTerminal: '装箱堆场',
      loadingRailwayStation: '装货站',
      loadingAirport: '装货机场',
      airportTerminal: '机场货站',
      cargoReadyTime: '货好时间',
      cargoType: '货物类型',
      unNo: 'UN编号',
      hazardClass: '危险品类别',
      cargoName: '货物名称',
      hsCode: 'HS编码',
      cargoValue: '货物价值',
      onePrice: '是否一口价',
      quotationDeadline: '报价截止时间',
      specialRequirements: '特殊要求',
      containerType: '箱型',
      containerNum: '箱量',
      quantityPerContainer: '每箱件数',
      weightPerContainer: '每箱毛重(KG)',
      totalQuantity: '总件数',
      totalWeight: '总毛重(KG)',
      totalVolume: '总体积(CBM)',
      summaryQuantity: '总件数',
      summaryWeight: '总毛重',
      summaryVolume: '总体积',
      temperatureRange: '温度范围(℃)',
      ventilationDoor: '通风门',
      ventilationQuantity: '风量',
      humidity: '湿度',
      needPrecooling: '是否预冷',
      quantity: '件数',
      weight: '毛重(KG)',
      length: '长(CM)',
      width: '宽(CM)',
      height: '高(CM)',
      lengthM: '长(M)',
      widthM: '宽(M)',
      heightM: '高(M)',
      packageType: '包装方式',
      truckType: '车辆类型'
    },

    enums: {
      paymentTerm: {
        PREPAID: '预付',
        COLLECT: '到付'
      },
      arrivalNodeType: {
        1: '海港',
        2: '铁路站点',
        3: '机场'
      },
      transportMode: {
        1: '拖车',
        2: '驳船',
        3: '铁路'
      },
      serviceType: {
        FCL: '整箱',
        LCL: '拼箱',
        TRUCK: '整车'
      },
      truckType: {
        1: '敞车',
        2: '棚车',
        3: '平车',
        4: '冷藏车',
        5: '矿石车',
        6: '水泥车'
      },
      consultationStatus: {
        1: '未磋商',
        2: '磋商中',
        3: '磋商完成'
      }
    },

    sections: {
      basic: '基础信息',
      cargo: '货物信息',
      plans: '报价方案',
      quotationDetail: '报价详情',
      consultationHistory: '磋商历史',
      baseFee: '基础费用',
      surcharge: '附加费',
      potentialFee: '潜在费用'
    },

    actions: {
      submit: '提交报价',
      addPlan: '新增方案',
      addBaseFee: '新增基础费',
      addSurcharge: '新增附加费',
      addPotentialFee: '新增潜在费用',
      save: '保存',
      initiateConsultation: '发起磋商',
      consultationContent: '磋商内容',
      consultationContentPlaceholder: '请输入磋商内容',
      cancel: '取消',
      consultationComplete: '磋商完成'
    },

    messages: {
      tokenInvalid: '无效的访问链接',
      quotationExpired: '报价已过期',
      loadFailed: '报价信息加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      quotationNotExist: '报价方案不存在',
      planCreated: '新增方案成功',
      planCreateFailed: '新增方案失败',
      deletePlanTitle: '删除方案',
      deletePlanContent: '确认删除该报价方案？',
      planDeleteSuccess: '删除方案成功',
      planDeleteFailed: '删除方案失败',
      requiredField: '{field} 为必填项',
      duplicateFeeName: '费用名称重复，请重新选择',
      planHasRequiredField: '方案 {index} 存在必填字段未填写',
      submitSuccess: '报价提交成功',
      submitFailed: '报价提交失败',
      validPeriodRequired: '请填写报价有效期',
      initiateConsultationSuccess: '发起磋商成功',
      initiateConsultationFailed: '发起磋商失败',
      consultationContentRequired: '请输入磋商内容'
    },
    consultationRecords: {
      currentVersion: '当前版本',
      expectedPrice: '期望价格',
      note: '备注',
      status: '状态',
      consulting: '磋商中',
      replied: '已回复',
      changeContent: '变更内容',
      messages: {
        noChange: '本次无变更',
        noConsultationRecords: '暂无磋商记录'
      },
      feeCategories: {
        BASE: '基础费用',
        SURCHARGE: '附加费',
        POTENTIAL: '潜在费用'
      },
      changeTypes: {
        added: '新增',
        removed: '删除',
        adjusted: '调整'
      }
    },

    placeholders: {
      select: '请选择',
      input: '请输入'
    }
  },

  // 尾程报价详情页
  supplierLastMileQuotation: {
    title: '尾程报价单详情',
    inquiryTitle: '尾程询价单',
    planTitle: '方案 {index}',
    emptyPlans: '暂无报价方案',
    emptyFees: '暂无费用',

    fields: {
      quotationNo: '报价编号',
      feeName: '费用名称',
      measure: '单位',
      containerTypeAndNum: '箱型箱量',
      unitRate: '单价',
      currency: '币种',
      paymentTerm: '付费条款',
      remarks: '备注',
      files: '附件',
      lastMileTransportMode: '运输方式',
      dischargingAddressType: '卸货地址类型',
      totalAmountByCurrency: '分币种合计',
      isOnePrice: '是否一口价',
      validPeriod: '报价有效期',
      serviceType: '服务类型',
      dischargingPort: '卸货港',
      deliveryTerminal: '卸货码头',
      dischargingStation: '卸货站',
      dischargingAirport: '卸货机场',
      airportTerminal: '机场货站',
      destinationPort: '驳船目的港',
      destinationStation: '目的站',
      dischargingCountry: '卸货国家',
      dischargingCity: '卸货城市',
      destinationCountry: '目的国家',
      destinationCity: '目的城市',
      deliveryAddressType: '配送地址类型',
      deliveryCountry: '配送国家',
      deliveryCity: '配送城市',
      deliveryAddress: '配送地址',
      postalCode: '邮编',
      cargoReadyTime: '货好时间',
      etd: '期望开航时间',
      cargoType: '货物类型',
      unNo: 'UN编号',
      hazardClass: '危险品类别',
      cargoName: '货物名称',
      hsCode: 'HS编码',
      cargoValue: '货物价值',
      onePrice: '是否一口价',
      quotationDeadline: '报价截止时间',
      specialRequirements: '特殊要求',
      containerType: '箱型',
      containerNum: '箱量',
      quantityPerContainer: '每箱件数',
      weightPerContainer: '每箱毛重(KG)',
      totalQuantity: '总件数',
      totalWeight: '总毛重(KG)',
      totalVolume: '总体积(CBM)',
      summaryQuantity: '总件数',
      summaryWeight: '总毛重',
      summaryVolume: '总体积',
      temperatureRange: '温度范围(℃)',
      ventilationDoor: '通风门',
      ventilationQuantity: '风量',
      humidity: '湿度',
      needPrecooling: '是否预冷',
      quantity: '件数',
      weight: '毛重(KG)',
      length: '长(CM)',
      width: '宽(CM)',
      height: '高(CM)',
      lengthM: '长(M)',
      widthM: '宽(M)',
      heightM: '高(M)',
      packageType: '包装方式',
      truckType: '整车类型'
    },

    enums: {
      paymentTerm: {
        PREPAID: '预付',
        COLLECT: '到付'
      },
      transportMode: {
        1: '拖车',
        2: '驳船',
        3: '铁路'
      },
      dischargingAddressType: {
        1: '海港',
        2: '铁路站点',
        3: '机场'
      },
      serviceType: {
        FCL: '整箱',
        LCL: '拼箱',
        TRUCK: '整车'
      },
      deliveryAddressType: {
        1: '第三方',
        2: '亚马逊',
        3: '易仓'
      },
      truckType: {
        1: '敞车',
        2: '棚车',
        3: '平车',
        4: '冷藏车',
        5: '矿石车',
        6: '水泥车'
      },
      consultationStatus: {
        1: '未磋商',
        2: '磋商中',
        3: '磋商完成'
      }
    },

    sections: {
      basic: '基础信息',
      cargo: '货物信息',
      plans: '报价方案',
      quotationDetail: '报价详情',
      consultationHistory: '磋商历史',
      baseFee: '基础费用',
      surcharge: '附加费',
      potentialFee: '潜在费用'
    },

    actions: {
      submit: '提交报价',
      addPlan: '新增方案',
      addBaseFee: '新增基础费',
      addSurcharge: '新增附加费',
      addPotentialFee: '新增潜在费用',
      save: '保存',
      initiateConsultation: '发起磋商',
      consultationContent: '磋商内容',
      consultationContentPlaceholder: '请输入磋商内容',
      cancel: '取消',
      consultationComplete: '磋商完成'
    },

    messages: {
      tokenInvalid: '无效的访问链接',
      quotationExpired: '报价已过期',
      loadFailed: '报价信息加载失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      quotationNotExist: '报价方案不存在',
      planCreated: '新增方案成功',
      planCreateFailed: '新增方案失败',
      deletePlanTitle: '删除方案',
      deletePlanContent: '确认删除该报价方案？',
      planDeleteSuccess: '删除方案成功',
      planDeleteFailed: '删除方案失败',
      requiredField: '{field} 为必填项',
      duplicateFeeName: '费用名称重复，请重新选择',
      planHasRequiredField: '方案 {index} 存在必填字段未填写',
      submitSuccess: '报价提交成功',
      submitFailed: '报价提交失败',
      validPeriodRequired: '请填写报价有效期',
      initiateConsultationSuccess: '发起磋商成功',
      initiateConsultationFailed: '发起磋商失败',
      consultationContentRequired: '请输入磋商内容'
    },
    consultationRecords: {
      currentVersion: '当前版本',
      expectedPrice: '期望价格',
      note: '备注',
      status: '状态',
      consulting: '磋商中',
      replied: '已回复',
      changeContent: '变更内容',
      messages: {
        noChange: '本次无变更',
        noConsultationRecords: '暂无磋商记录'
      },
      feeCategories: {
        BASE: '基础费用',
        SURCHARGE: '附加费',
        POTENTIAL: '潜在费用'
      },
      changeTypes: {
        added: '新增',
        removed: '删除',
        adjusted: '调整'
      }
    },

    placeholders: {
      select: '请选择',
      input: '请输入'
    }
  }
}
